module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-913a2634.png";